module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/uzemniPlanovani-8867c96d98759f384f3e8461b947720f.png";